import { Colors } from '@fourthwall/components/dist/colors';
import styled from 'styled-components';
export const JoinChallengeContainer = styled.div `
  display: flex;
  align-items: center;
`;
export const CurrentChallengeProgressContainer = styled.div `
  margin-top: 15px;
`;
export const ButtonsWrapper = styled.div `
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 20px;
  ${({ $fullWidth }) => (!$fullWidth ? 'width: 100%;' : '')}
`;
export const ProgressBarContainer = styled.div `
  margin-top: 16px;
`;
export const ProgressSubtitles = styled.div `
  margin-top: 8px;
  font-size: 14px;
  color: ${Colors.GS550};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Counter = styled.span `
  display: flex;
  align-items: center;
  gap: 4px;
`;
